export type NumberConvertableToWord = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

const numbersToWords: Record<NumberConvertableToWord, string> = {
  0: "zero",
  1: "one",
  2: "two",
  3: "three",
  4: "four",
  5: "five",
  6: "six",
  7: "seven",
  8: "eight",
  9: "nine",
};

export function isNumberConvertableToWord(
  maybeNumberConvertableToWord: number
): maybeNumberConvertableToWord is NumberConvertableToWord {
  return maybeNumberConvertableToWord >= 0 && maybeNumberConvertableToWord <= 9;
}

export function convertNumberToWord(numberConvertableToWord: NumberConvertableToWord): string {
  return numbersToWords[numberConvertableToWord];
}
